import { render } from "./ContactLeft.vue?vue&type=template&id=5ffa0f3a&scoped=true&ts=true"
import script from "./ContactLeft.vue?vue&type=script&lang=ts"
export * from "./ContactLeft.vue?vue&type=script&lang=ts"

import "./ContactLeft.vue?vue&type=style&index=0&id=5ffa0f3a&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffa0f3a"]])

export default __exports__